import React from 'react';
import diners from 'assets/images/diners.svg';
import { SvgIconProps } from '@mui/material';

export const AfDinersIcon: React.FC<SvgIconProps> = () => {
  return <img src={diners} />;
};
